/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesBracketSchema } from "./bracketSchema.ts";
import { goodLuckCoreEntitiesDraftTeamSchema } from "./draftTeamSchema.ts";
import { goodLuckCoreEntitiesMatchPhaseSchema } from "./matchPhaseSchema.ts";
import { goodLuckCoreEntitiesMatchStatusSchema } from "./matchStatusSchema.ts";
import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTournamentTeamSchema } from "./tournamentTeamSchema.ts";
import { goodLuckCoreEntitiesWinConditionTypeSchema } from "./winConditionTypeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesMatchSchema = z.object({
  id: z.string().nullish(),
  bracketId: z.string().nullish(),
  round: z.optional(z.int()),
  matchNumber: z.optional(z.int()),
  bestOf: z.optional(z.int()),
  team1Id: z.string().nullish(),
  team2Id: z.string().nullish(),
  draftTeam1Id: z.string().nullish(),
  draftTeam2Id: z.string().nullish(),
  participant1Id: z.string().nullish(),
  participant2Id: z.string().nullish(),
  winnerId: z.string().nullish(),
  team1Score: z.optional(z.int()),
  team2Score: z.optional(z.int()),
  get status() {
    return goodLuckCoreEntitiesMatchStatusSchema.optional();
  },
  get phase() {
    return goodLuckCoreEntitiesMatchPhaseSchema.optional();
  },
  scheduledTime: z.iso.datetime().nullish(),
  startTime: z.iso.datetime().nullish(),
  pausedAtUtc: z.iso.datetime().nullish(),
  team1PausesUsed: z.optional(z.int()),
  team2PausesUsed: z.optional(z.int()),
  pausedByTeamId: z.string().nullish(),
  completedAt: z.iso.datetime().nullish(),
  pendingResultWinnerId: z.string().nullish(),
  pendingResultTeam1Score: z.int().nullish(),
  pendingResultTeam2Score: z.int().nullish(),
  pendingResultByUserId: z.string().nullish(),
  pendingResultByTeamId: z.string().nullish(),
  pendingResultAtUtc: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
  tournamentCode: z.string().nullish(),
  riotGameId: z.string().nullish(),
  get winCondition() {
    return goodLuckCoreEntitiesWinConditionTypeSchema.optional();
  },
  tournamentId: z.string().nullish(),
  nextMatchId: z.string().nullish(),
  winnerNextMatchId: z.string().nullish(),
  winnerNextSlot: z.string().nullish(),
  loserNextMatchId: z.string().nullish(),
  loserNextSlot: z.string().nullish(),
  bracketSection: z.string().nullish(),
  sectionRound: z.int().nullish(),
  position: z.optional(z.int()),
  scheduledAt: z.iso.datetime().nullish(),
  isTechnicalWin: z.optional(z.boolean()),
  preDraftRoomId: z.string().nullish(),
  preDraftBlueLink: z.string().nullish(),
  preDraftRedLink: z.string().nullish(),
  preDraftSpectatorLink: z.string().nullish(),
  preDraftDeadlineUtc: z.iso.datetime().nullish(),
  currentGameIndex: z.optional(z.int()),
  seriesPickedChampionIds: z.string().nullish(),
  lastGameWinnerId: z.string().nullish(),
  get bracket() {
    return goodLuckCoreEntitiesBracketSchema.optional();
  },
  get team1() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  get team2() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  get draftTeam1() {
    return goodLuckCoreEntitiesDraftTeamSchema.optional();
  },
  get draftTeam2() {
    return goodLuckCoreEntitiesDraftTeamSchema.optional();
  },
  get participant1() {
    return goodLuckCoreEntitiesTournamentTeamSchema.optional();
  },
  get participant2() {
    return goodLuckCoreEntitiesTournamentTeamSchema.optional();
  },
});
